import { Injectable, EventEmitter, Inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { MatSnackBar } from '@angular/material';
import { environment } from '../../environments/environment';


@Injectable()
export class UtilsService {


  public menuToggled$: EventEmitter<any>;
  public menuState = false;

  private _algolia = new Subject<any>();
  private _explorePage = new Subject<any>();
  private _wishList = new Subject<any>();

  public apiEndpoint = `${environment.server}api/`;


  public algolia = {
    url: 'https://e5wbh6dvia-dsn.algolia.net/1/indexes/*/queries',
    params: {
      'x-algolia-agent': 'Algolia for vanilla JavaScript 3.24.9',
      'x-algolia-application-id': 'E5WBH6DVIA',
      'x-algolia-api-key': 'ea9abfff895eccd0c17aad08378e50c3'
    },
    queryParams: '',
    request: {
      indexName: 'prod_ATTRACTION',
      params: 'facetFilters=published:true&query='
    }
  };

  constructor(
    private httpClient: HttpClient,
    public snackBar: MatSnackBar,
    @Inject(DOCUMENT) private document: any
  ) {
    this.menuToggled$ = new EventEmitter();
    this.algolia = this.getAlgolia();
  }

  getAlgolia() {
    let algoliaP = '';
    const that = this;
    Object.keys(that.algolia.params).forEach(key => {
      if (algoliaP !== '') {
        algoliaP += '&';
      }
      algoliaP += key + '=' + encodeURIComponent(that.algolia.params[key]);
    });

    that.algolia.queryParams = algoliaP;
    that.algolia.url = that.algolia.url + '?' + that.algolia.queryParams;
    return this.algolia;
  }

  newAlgoliaEvent(event) {
    this._algolia.next(event);
  }

  get algoliaEvents$() {
    return this._algolia.asObservable();
  }

  newExplorePageEvent(event) {
    this._explorePage.next(event);
  }

  get explorePageEvents$() {
    return this._explorePage.asObservable();
  }

  newWishEvent(event) {
    this._wishList.next(event);
  }

  get wishEvents$() {
    return this._wishList.asObservable();
  }

  toggleMenu() {
    this.menuState = !this.menuState;
    this.menuToggled$.emit(this.menuState);
  }

  getMenuState() {
    return this.menuState;
  }

  ixs(): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.get(this.apiEndpoint + 'ix', {
      responseType: 'json',
      headers: httpHeaders
    });
  }

  ix(path): Observable<any> {

    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const params: HttpParams = new HttpParams().set('path', path);

    return this.httpClient.get(this.apiEndpoint + 'ix', {
      responseType: 'json',
      headers: httpHeaders,
      params: params
    });

  }

  getVideo(query): Observable<any> {

    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.apiEndpoint + 'cloudfront', query, {
      responseType: 'json',
      headers: httpHeaders
    });

  }

  generateRandomString() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }


  getFile(url: string) {
    return this.httpClient.get(url, {observe: 'response', responseType: 'blob'})
      .map((res) => {
        return new Blob([res.body], {type: res.headers.get('Content-Type')});
      });
  }


  openSnackBar(message: string, action: string) {
    //noinspection TypeScriptValidateTypes
    this.snackBar.open(message, action, {duration: 3000});
  }

  validateRequiredFields(...args: any[]) {
    let success = true;
    if (args && args.length > 0) {
      args.forEach(arg => {
        if (typeof (arg) === 'object') {
          if (arg.length !== undefined) {
            success = success && (arg.length > 0);
          }
        } else {
          success = success && (arg && arg.trim());
        }
      });
      if (!success) {
        this.openSnackBar('Some required fields are missing.', 'error');
      }
    }
    return success;
  }

  chunkArray(array, size) {
    const localArray = Array.from(array);
    const results = [];
    while (localArray.length) {
      results.push(localArray.splice(0, size));
    }
    return results;
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/utils.service.ts